import React, { useEffect } from 'react';
import { graphql, useStaticQuery } from 'gatsby';

export const TypeFormPopUp = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = '//embed.typeform.com/next/embed.js';
    script.async = true;

    document.head.appendChild(script);
  }, []);
  return (
    <>
      <style jsx global>
        {`
    .tf-v1-sidetab-button {
      transform: rotate(90deg) translate(-50%, -100%);
      left: 100%;
    }
    .tf-v1-sidetab {
      left: 0;
      right: auto;
      transform: translate(-100%, -50%);
    }

    @media (max-width:481px) {
      .tf-v1-sidetab {
        top: 80%;
      }
    }
    `}
      </style>
      <div
        data-tf-live="01HXV7DYXKHKPJSF16FATX8MNT"
      />
    </>
  );
};
